<template>
  <div>
    <top></top>
    <!-- 轮播图 -->
    <el-carousel class="index-swiper-img" height='680px'>
      <el-carousel-item class="index-swiper-img">
        <img class="index-swiper-img" src="../../static/images/index_swiper.jpg"/>
      </el-carousel-item>
      <el-carousel-item class="index-swiper-img">
        <img class="index-swiper-img" src="../../static/images/index_swiper1.jpg"/>
      </el-carousel-item>
    </el-carousel>
    <!-- 服务项目 -->
    <div class="contents display_center">
      <div class="content">
        <div class="server_item_box">
          <div class="display_center server_item_tit">
            服务项目
          </div>
          <div class="display_center content server_item_label">
            ——  service center ——
          </div>
        </div>
        <div class="display_space">
          <div class="server_box pointer" @click="skipPage('/occupationalHygiene')">
            <div class="display_center">
              <div class="img_box display_center">
                <img src="../../static/images/index_icon3.png"/>
              </div>
            </div>
            <div class="title_box">
              职业卫生检测与评价
              <div class="title_bottom_border"></div>
            </div>
            <div class="three_line text_box">
              1 建设项目职业病危害预评价本机构受建设单位委托，为建设单位依法履行《中华人民共和国职业病防治法》第十七条的规定提供评价技术服务：新建、扩建、改建建设项目和技术改造、技术引进项目可能产生职业病危害的建设单位，编制《建设项目职业病危害与评价报告书》，为保障建设单位职业健康管理的依法规范经营提供技术依据和技术服务。2 建设项目职业病防护设施设计 本机构受建设单位委托，为建设单位依法履行《中华人民共和国职业病防治法》第十八条的规定提供技术服务：建设项目的职业病防护设施设计应当符合国家职业卫生标准和卫生要求；《浙江省建设项目职业病防护设施“三同时”》第十四条，存在职业病危害的建设项目，建设单位应当在施工前按照职业病防治有关法律、法规、规章和标准的要求，进行职业病防护设施设计。为保障建设单位职业健康管理的依法规范经营提供技术依据和技术服务。3 建设项目职业病危害控制效果评价 本机构受建设单位委托，为建设单位依法履行《中华人民共和国职业病防治法》第十八条的规定提供评价技术服务：建设项目在竣工验收前，建设单位应当进行职业病危害控制效果评价。为保障建设单位职业健康管理的依法规范经营提供技术依据和技术服务。4 用人单位职业病危害现状评价 本机构受用人单位委托，根据国家安全生产监督管理总局令第47号第二十条提供评价技术服务：职业病危害严重的用人单位，应当委托具有相应资质的职业卫生技术服务机构，每三年至少进行一次职业病危害现状评价；第二十一条：存在职业病危害的用人单位，有下述情形之一的，应当及时委托具有相应资质的职业卫生技术服务机构进行职业病危害现状评价：（一）初次申请职业卫生安全许可证，或者职业卫生安全许可证有效期届满申请换证的；（二）发生职业病危害事故的；（三）国家安全生产监督管理总局规定的其他情形。5 工作场所职业病危害因素检测与评价（定期检测） 本机构受用人单位委托，根据《中华人民共和国职业病防治法》第二十六条的规定提供检测评价服务：用人单位应当按照国务院安全生产监督管理部门的规定，定期对工作场所进行职业病危害因素检测、评价。检测、评价结果存入用人单位职业卫生档案，定期向所在地安全生产监督管理部门报告并向劳动者公布。为建设单位办理职业卫生行政网上申报和员工体检提供技术依据和技术服务。
            </div>
          </div>
          <div class="server_box pointer" @click="skipPage('/safetyAssessment')">
            <div class="display_center">
              <div class="img_box display_center">
                <img src="../../static/images/index_icon2.png"/>
              </div>
            </div>
            <div class="title_box ">
              安全技术服务
              <div class="title_bottom_border"></div>
            </div>
            <div class="three_line text_box">
              1、建设项目设立安全评价（安全预评价） 本机构受建设单位委托，为建设单位依法履行《中华人民共和国安全生产法》第二十九条的规定提供评价技术服务：矿山、金属冶炼建设项目和用于生产、储存、装卸危险物品的建设项目，应当按照国家有关规定进行安全评价；《建设项目安全设施“三同时”监督管理暂行办法》国家安全生产监督管理总局令第36号，第七条：建设项目在进行可行性研究时，生产经营单位应当分别对其安全生产条件进行论证和安全预评价。为保障建设单位安全管理的依法规范经营提供技术依据和技术服务。2 、建设项目安全设施竣工验收评价             为建设单位依法履行《中华人民共和国安全生产法》第二十九条的规定提供评价技术服务：矿山、金属冶炼建设项目和用于生产、储存、装卸危险物品的建设项目，应当按照国家有关规定进行安全评价；《建设项目安全设施“三同时”监督管理暂行办法》国家安全生产监督管理总局令第36号，第二十三条：建设项目安全设施竣工或者试运行完成后，生产经营单位应当委托具有相应资质的安全评价机构对安全设施进行验收评价，并编制建设项目安全验收评价报告。为保障建设单位安全管理的依法规范经营提供技术依据和技术服务。 3、生产经营单位安全现状评价             为建设单位依法履行《中华人民共和国安全生产法》第二十九条的规定提供评价技术服务：矿山、金属冶炼建设项目和用于生产、储存、装卸危险物品的建设项目，应当按照国家有关规定进行安全评价；《危险化学品安全管理条例》中华人民共和国国务院令第645号，第二十二条，生产、储存危险化学品的企业，应当委托具备国家规定的资质条件的机构，对本企业的安全生产条件每3年进行一次安全评价，提出安全评价报告。为保障生产经营单位安全管理的依法规范经营提供技术依据和技术服务。 4、其他相关服务             提供其他技术服务：区域安全风险评估、安全生产隐患排查与治理、安全标准化咨询等。
            </div>
          </div>
          <div class="server_box pointer" @click="skipPage('/environmentDetection')">
            <div class="display_center">
              <div class="img_box display_center">
                <img src="../../static/images/index_icon1.png"/>
              </div>
            </div>
            <div class="title_box">
              环保技术服务
              <div class="title_bottom_border"></div>
            </div>
            <div class="three_line text_box">
              1、环境现状监测             在环境影响评价工作中，环境现状监测是获得环境质量现状基线值的过程，它给环境影响评价提供必不可少的基础数据。 2、环境影响评价检测             所有可能对环境造成影响的建设项目，必须进行环境影响评价。环境监测可以给环境影响评价提供必不可少的基础数据，是环境影响评价工作中非常重要的一环。3、ISO 14000检测服务            ISO 14000体系的建立必须经过环境监测。环境检测为ISO14000体系的完善提供必要的数据。 4、建设项目竣工环境保护验收监测            按环保法和国务院建设项目环境保护条例等规定、相关技术规范执行。
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="contents display_center aboutus_box">
      <div class="aboutus_div">
        <div>
          <div class="aboutus_tit_box">
            <div class="display_center content title-text1">
              关于我们
            </div>
            <div class="display_center content title-text2">
              —— ABOUT US ——
            </div>
          </div>
          <div class="aboutus_content_box">
            杭州盛弘检测科技有限公司创办于2021年8月，注册资金500万，其中固定资产200多万元，是专业技术服务机构，具有独立的法人资格。 公司目前的主要业务包括：职业病危害检测与评价、安全技术服务、环保技术服务等。 公司现有专业技术人员30人，其中高级工程师3人、中级以上技术人员10人，公司全部员工均具有大学专科以上文化程度。公司拥有固定的办公场所，办公场所面积1000平方米，其中实验区约500平方米。 公司设有质管部、检测部、职评部、办公室等多个部门。是一支年青化、素质高、技能强、敬业好的专业技术队伍。同时公司现已配备了气相色谱仪、原子吸收分光光度计、紫外可见分光光度计、十万分之一电子天平、万分之一电子天平等大型精密仪器设备，并配备有烘箱、冷藏箱等辅助设备，确保了监测工作的准确性、科学性、权威性。检测能力覆盖矿山，化工、石化、医药，冶金、建材，机械制造、电力、纺织、建筑和交通运输等行业领域。 公司始终坚持“科学、公正、准确、高效、规范”的质量方针，公司宗旨是对社会和顾客高度负责，提供权威、公正、科学的报告，让社会和顾客持续满意。
          </div>
        </div>
        <div>
          <img  src="../../static/images/index_aboutBg.jpg"/>
        </div>
      </div>
    </div>

    <!-- 新闻资讯 -->
    <div class="contents display_center">
      <div class="content">
        <div class="server_item_box">
          <div class="display_center server_item_tit">
            新闻资讯
          </div>
          <div class="display_center content server_item_label">
            ——  News and information ——
          </div>
          <div class="display_center newsMore" @click="goNewsList">More</div>
        </div>
        <div class="newsList">
          <div v-for="(item,index) in newsList" :key="index" class="news_box" @click="goReportInfo(item)">
            <el-card shadow="hover">
              <div class="news_img">
                <el-image style="width: 240px;height: 240px;" class="news_img" fit='cover' :src="'https://www.hzshjc.com/' + item.picture"></el-image>
              </div>
              <div class="news_title">
                {{item.title}}
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from '@/components/top.vue';
import menutree from '@/components/menutree.vue';
import bottom from '@/components/bottom.vue';
export default {
  components:{top,menutree,bottom},
  data () {
    return {
      newsList:[]
    }
  },
  mounted() {
    this.getNews()
  },
  methods:{
    goReportInfo(item){
      const{ href } = this.$router.resolve({name:'newsInfo',query:{id:item.id}})
      // console.log(newPage)
      window.open(href,'_blank')
    },
    skipPage(pagePath){
      this.$router.push(pagePath)
    },
    getNews(){
      const url=`https://api.hzshjc.com/index/newsList`;
      let data = {
        pageSize:3,
        pageNo:1,
      }
      this.$axios({
        method:'get',
        url:url,
        params:data
      }).then(res=>{
        if(res.data.code=='200'){
          this.newsList = res.data.rows
        }
      })
    },
    goNewsList(){
      this.$router.push('/newsList')
    }
  }
}
</script>

<style scope lang="less">
  .index-swiper-img{
    width: 100%;
    height: 680px;
  }
  .server_item_box{
    padding: 62px 0 36px;
    .server_item_tit{
      font-size: 34px;
      color: #333;
      line-height: 34px;
      margin-bottom: 5px;
    }
    .server_item_label{
          font-size: 14px;
          color: #999;
          text-transform: uppercase;
          line-height: 18px;
    }
  }
  .server_box{
    width: 300px;
    height: 267px;
    overflow: hidden;
    padding:30px 21px;
    border: 1px solid #ddd;
    border-radius: 8px;
    .img_box{
      height: 123px;
      width: 123px;
      border-radius: 50%;
      border: 1px solid #00a73c;
      img{
        width: 61px;
        height: 61px;
      }
    }
    .title_box{
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      color: #333;
      margin-top: 10px;
      .title_bottom_border{
        width: 20px;
        height: 3px;
        background-color: #ccc;
        margin: 0 auto 10px;
      }
    }
    .text_box{
      line-height: 24px;
      overflow: hidden;
      font-size: 14px;
      color: #333;
      margin: 20px 0;
    }
  }
  .server_box:hover{
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
    box-shadow:  2px 5px 5px 1px rgba(0, 0, 0, 0.05);
  }
  .aboutus_box{
    width: 100%;
    margin-top: 100px;
    // background: url(../../static/images/index_aboutBg.jpg) no-repeat center top;
    // background-size: 100% 100%;
    background:-webkit-linear-gradient(to left,  #7d7888,#a8a4af);
    background:linear-gradient(to left,#7d7888,#a8a4af);
    height: 580px;
    .aboutus_div{
      width: 1200px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .aboutus_tit_box{
        width: 600px;
        margin-top: 30px;
        .title-text1{
          text-align: center;
          width: 600px;
          font-size: 34px;
          color: #FFF;
          line-height: 34px;
          margin-bottom: 5px;
        }
        .title-text2{
          text-align: center;
          width: 600px;
          font-size: 14px;
          color: #FFF;
          line-height: 18px;
          display: block;
        }
      }
      .aboutus_content_box{
        text-align: left;
        width: 560px;
        margin-top: 30px;
        line-height: 30px;
        font-size: 15px;
        color: #333;
        text-align: left;
        margin-bottom: 42px;
        text-indent:2em;
      }
      .learn-more{
        width: 200px;
        height: 46px;
        color: #333;
        font-size: 16px;
        text-align: center;
        line-height: 46px;
        border: 1px #666 solid;
        margin: 80px auto 0;
        display: block;
        text-transform: uppercase;
        border-radius: 5px;
        -moz-border-radius: 5px;
        -webkit-border-radius: 5px;
        margin-bottom: 40px;
      }
      img{
        box-shadow: 5px 5px 10px 10px #7d7888;
      }
    }
  }
  .newsMore{
    cursor:pointer;
    color: dodgerblue;
  }
  .newsList{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:20px 0;
    .news_box{
      width: 280px;
      cursor:pointer;
      .news_img{
        .img{
          width: 300px;
          height: 300px;
        }
      }
      .news_title{
        height: 60px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;				//溢出内容隐藏
        text-overflow: ellipsis;		//文本溢出部分用省略号表示
        display: -webkit-box;			//特别显示模式
        -webkit-line-clamp: 2;			//行数
        line-clamp: 2;
        -webkit-box-orient: vertical;	//盒子中内容竖直排列
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue